export const VIDEO_CREATE_RESET = 'VIDEO_CREATE_RESET';
export const VIDEO_CREATE_SET_CREATED = 'VIDEO_CREATE_SET_CREATED';
export const VIDEO_CREATE_SET_ERROR = 'VIDEO_CREATE_SET_ERROR';
export const VIDEO_CREATE_SET_VIOLATIONS = 'VIDEO_CREATE_SET_VIOLATIONS';
export const VIDEO_CREATE_TOGGLE_LOADING = 'VIDEO_CREATE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/video/create/mutation_types.js